import { INIT, INIT_SUCCESS, INIT_FAILED, SET_SEARCH, SET_TIME } from './constants';

export const initAction = (deedType) => ({
  type: INIT,
  deedType,
});

export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error) => ({
  type: INIT_FAILED,
  error,
});

export const setSearchAction = (search) => ({
  type: SET_SEARCH,
  search,
});

export const setTimeAction = (time) => ({
  type: SET_TIME,
  time,
});
